import { ReactNode, useEffect, useState } from "react";
import Box from "../../../../components/layout/Box";
import Link from "../../../../components/navigation/Link";
import ProgressBar from "../../../../components/navigation/ProgressBar";
import { ChevronLeft, ChevronRight } from "react-feather";

// Custom hook to get window width
function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array to run effect only once

  return width;
}

type SimulatorLayoutBaseProps = {
  dynNumber?: number;
  children: ReactNode;
  isCtaDisabled: boolean;
  onCtaClick: () => void;
  isLastStep: boolean;
};
type SimulatorLayoutProps =
  | (SimulatorLayoutBaseProps & {
      isFirstStep: true;
      onPreviousClick?: undefined;
    })
  | (SimulatorLayoutBaseProps & {
      isFirstStep: false;
      onPreviousClick: () => void;
    });
const SimulatorLayout = ({
  dynNumber,
  children,
  isCtaDisabled,
  onCtaClick,
  isLastStep,
  isFirstStep,
  onPreviousClick,
}: SimulatorLayoutProps) => {
  const mainLinkContent = isLastStep ? (
    <b>Terminer</b>
  ) : (
    <Box flex justifyContent="center" alignItems="center">
      <b>Continuer</b> <ChevronRight />
    </Box>
  );

  const windowWidth = useWindowWidth();
  // Example condition based on window width
  const shouldDisplayComponent = windowWidth > 600; // Example threshold

  return (
    <Box flexRatio={1} all="m" flex col>
      <Box col flexRatio={1} gap="m">
        {children}
      </Box>

      <Box padding={{ inline_end: "xl", inline_start: "xl" }} gap="m" flex alignItems="center" justifyContent="start" reverse>
        <Link disabled={isCtaDisabled} onClick={onCtaClick}>
          {mainLinkContent}
        </Link>
        <ProgressBar dynNumber={dynNumber} />
        {!isFirstStep &&  shouldDisplayComponent && (
          <Link onClick={onPreviousClick}>
            <Box flex justifyContent="center" alignItems="center">
              <ChevronLeft /> Retour
            </Box>
          </Link>
        )}
      </Box>

      <Box>
      {!isFirstStep &&  !shouldDisplayComponent && (
          <Link onClick={onPreviousClick}>
            <Box flex justifyContent="center" alignItems="center">
              <ChevronLeft /> Retour
            </Box>
          </Link>
        )}
      </Box>
    </Box>
  );
};

const TotalSteps = 13;

export { SimulatorLayout, TotalSteps };
